<template>
  <div class="choose-photos-step">
    <h1 class="global-h1">Upload Photos for a Post</h1>

    <div style="margin-top: 20px; margin-bottom: 30px">
      <UploadPhotosNonAdventure :customerId="customerId" @imageAddedToGallery="addImageToNonAdventureGallery"></UploadPhotosNonAdventure>
    </div>

    <div class="choose-photos-step__or-divider"></div>

    <div style="margin-top: 30px; margin-bottom: 20px">
      <div>TODO: Convey that we'll use all their photos by default, and then collapse this?</div>
      <div v-if="!allPhotos" class="social-post-gen-from-photos__placeholder">Loading photos...</div>
      <PhotosSpoiler
        v-else
        class="all-photos-with-grouping__photos-spoiler"
        title="Select Specific Photos (all included by default)"
        :photosList="allPhotos"
        :isThumbnailsWithDownloadButton="false"
        :isThumbnailsWithCheckboxes="true"
        :checkedFiles="checkedFiles"
        @checkUncheckFile="handleCheckUncheckFile"
        @checkUncheckAll="handleCheckUncheckAll"
        :isThumbnailsEntireAreaClickable="true"
        :isThumbnailsEntireAreaCheckable="true"
        :isWithSelectAllCheckbox="false"
        :showManageUploads="false"
        @manageUploads="manageUploadsClicked"
      >
      </PhotosSpoiler>
    </div>
  </div>
</template>

<script setup lang="ts">
import PhotosSpoiler from "@components/AllPhotosSection/PhotosSpoiler.vue";
import UploadPhotosNonAdventure from "@views/CMS/UploadPhotosNonAdventure.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const props = defineProps<{
  customerId: string;
  allPhotos: string[];
}>();

const checkedFiles = ref<string[]>([]);

const manageUploadsClicked = () => {
  router.push({ name: "PhotoGalleryAdmin" });
};

const handleCheckUncheckFile = (fileName: string, isChecked: boolean) => {
  if (isChecked) {
    checkedFiles.value = [...checkedFiles.value, fileName];
  } else {
    checkedFiles.value = checkedFiles.value.filter(f => f !== fileName);
  }
  emit("checkUncheckFile", fileName, isChecked);
};

const handleCheckUncheckAll = (isChecked: boolean) => {
  checkedFiles.value = isChecked ? [...props.allPhotos] : [];
  emit("checkUncheckAll", props.allPhotos, isChecked);
};

const addImageToNonAdventureGallery = (imageId: string) => {
  emit("imageAddedToGallery", imageId);
};

const emit = defineEmits<{
  (e: "checkUncheckFile", fileName: string, isChecked: boolean): void;
  (e: "checkUncheckAll", photos: string[], isChecked: boolean): void;
  (e: "imageAddedToGallery", imageId: string): void;
}>();
</script>

<style scoped lang="scss">
.choose-photos-step {
  &__or-divider {
    width: 100%;
    height: 40px;
    margin-bottom: 5px;
    position: relative;
    z-index: 0;

    &::before {
      content: "";
      width: 100%;
      height: 0;
      border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
      position: absolute;
      inset: 50% auto auto 0;
    }

    &::after {
      content: "or";
      width: 41px;
      height: 41px;
      padding: 0 0 2px;
      box-sizing: border-box;
      border: 1px rgba(0, 0, 0, 0.2) solid;
      border-radius: 1000px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      inset: 0 auto auto calc(50% - 20px);
      color: rgba(0, 0, 0, 1);
      font:
        600 19px/19px "Quicksand",
        sans-serif;
      background: white; // rgb(243, 243, 243);
    }
  }
}
</style>
